'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _count2 = require('./internal/_count');

var _count3 = _interopRequireDefault(_count2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns the number of values in `subject`.
 *
 * @example
 * count(List.of(1, 2, 3)) === 3;
 *
 * @param {TYPE} subject
 * @return {number}
 */
exports.default = _count3.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/count.js
// module id = 343
// module chunks = 0 1